import { GET, POST, PUT, DELETE } from './api';

export const ReadHome = async () => {
  // The `home` single-type schema has ONLY a repeatable `featured` component
  // (featured_show + featured_banner) — NO `icon` field. A stray
  // `populate[2]=icon` made Strapi 5 reject the whole request with
  // 400 ValidationError "Invalid key icon", so Home rendered EMPTY (no featured
  // shows) and every catalog/player e2e flow had nothing to open. `icon` is a
  // valid populate for /tabs and /collections, not /home.
  //
  // Strapi 5 ALSO dropped v4's dot-notation populate (`featured.featured_show`):
  // it returns `featured` with its relations UNPOPULATED, so featured_show /
  // featured_banner arrive without name/url and parseBanner renders empty. The
  // nested-object populate works on both v4 and v5 (mirrors mobile ReadHome).
  return await GET(
    `/home?populate[featured][populate][featured_show][populate]=*&populate[featured][populate][featured_banner][populate]=*`,
  );
};

export const ReadHomeTabs = async () => {
  return await GET(`/tabs?populate[0]=icon`);
};

export const ReadTabPlaylist = async () => {
  return await GET(`/collections?populate[0]=stream_shows.thumbnail&populate[1]=icon`);
};

export const ReadTabCatalog = async (tabId: number | string) => {
  return await GET(
    `/collections?filters[tab]=${tabId}&populate[0]=stream_shows.thumbnail&populate[1]=icon`,
  );
};

export const ReadCatalogDetails = async (catalogId: number | string) => {
  return await GET(`/collections/${catalogId}?populate[0]=stream_shows.thumbnail&populate[1]=icon`);
};

export const ReadCategories = async () => {
  return await GET(`/categories`);
};

export const ReadSearch = async (searchExpression: string) => {
  return await GET(
    `/stream-shows/?pagination[start]=1&[limit]=20&[populate][0]=thumbnail&filters[name][$containsi]=${searchExpression}`,
  );
};

export const ReadSearchByTheme = async (themeId: number | string) => {
  return await GET(
    `/stream-shows/?pagination[start]=1&[limit]=20&[populate][0]=thumbnail&filters[themes]=${themeId}`,
  );
};

export const ReadSearchByCharacter = async (charId: number | string) => {
  return await GET(
    `/stream-shows/?pagination[start]=1&[limit]=20&[populate][0]=thumbnail&filters[characters]=${charId}`,
  );
};

export const ReadKids = async () => {
  return await GET(`/collections?filters[name]=Kids&populate[0]=stream_shows`);
};

export const ReadProgressPlayer = async (
  streamId: number | string,
  profileId: number | string,
  token: string,
) => {
  return await GET(
    `/progress-players?filters[profile]=${profileId}&filters[stream_show]=${streamId}&sort[0]=id:desc`,
    token,
  );
};

export const CreateProgressPlayer = async (body: unknown, token: string) => {
  return await POST(`/progress-players`, body, token);
};

export const ReadKeepWatching = async (id: number | string, token: string) => {
  return await GET(
    `/progress-players?filters[profile]=${id}&populate=stream_show.thumbnail&sort[0]=createdAt:desc&sort[1]=updatedAt:desc&pagination[pageSize]=1000`,
    token,
  );
};

export const UpdateProgressPlayer = async (id: number | string, body: unknown, token: string) => {
  return await PUT(`/progress-players/${id}`, body, token);
};

export const ReadShowDetails = async (showId: number | string, token: string) => {
  return await GET(
    `/stream-shows/${showId}?[populate][0]=thumbnail&[populate][1]=wide_picture&[populate][2]=related_shows.thumbnail&[populate][3]=stream_master_file&[populate][4]=mobile_download_mp4&[populate][5]=next_stream`,
    token,
  );
};

export const ReadPreviewsShow = async (showId: number | string, token: string) => {
  // v5 relation filter + pagination syntax (main hotfix; mirrors web catalog.ts fix).
  return await GET(
    `/stream-shows?filters[next_stream][documentId][$eq]=${showId}&pagination[limit]=1`,
    token,
  );
};

export const ReadSerchableCharacteres = async () => {
  return await GET(`/characters`);
};

export const ReadSerchableThemes = async () => {
  return await GET(`/themes`);
};
